// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/emergency-contacts",
  Create: "/pyr/employees/{employeeId}/emergency-contacts",
  Update: "/pyr/employees/{employeeId}/emergency-contacts",
  Detail: "/pyr/employees/{employeeId}/emergency-contacts",
};
